import { render, staticRenderFns } from "./app-icon.vue?vue&type=template&id=0e5d17c9"
import script from "./app-icon.vue?vue&type=script&lang=ts"
export * from "./app-icon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/volateq-web-app/volateq-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e5d17c9')) {
      api.createRecord('0e5d17c9', component.options)
    } else {
      api.reload('0e5d17c9', component.options)
    }
    module.hot.accept("./app-icon.vue?vue&type=template&id=0e5d17c9", function () {
      api.rerender('0e5d17c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/app-icon/app-icon.vue"
export default component.exports